import React, { ReactNode } from 'react';
import { Tooltip } from './Tooltip';
import classNames from 'classnames';
import styled from '@emotion/styled';

export interface DisabledTooltipProps {
  className?: string;
  /**
   * disabled 상태일 때만 Tooltip이 동작하고 children 요소는 disabled 상태로 변경됩니다.
   */
  disabled: boolean;
  /** @default 'bottom' */
  placement?: 'top' | 'bottom' | 'left' | 'right';
  content: ReactNode;
  children: React.ReactElement;
  /** @default 'hover' */
  openerTriggerEvent?: 'click' | 'hover' | 'none';
}

export const DisabledTooltip = ({
  className,
  disabled,
  content,
  placement = 'bottom',
  children,
  openerTriggerEvent = 'hover',
}: DisabledTooltipProps) => {
  if (disabled) {
    const disabledChildren = React.cloneElement(children, {
      ...children.props,
      disabled: true,
    });
    return (
      <Tooltip
        className={classNames('pds-disabled-tooltip', className)}
        content={content}
        kind='neutral'
        placement={placement}
        openerTriggerEvent={openerTriggerEvent}
      >
        <SC.Container className='pds-disabled-tooltip-content'>{disabledChildren}</SC.Container>
      </Tooltip>
    );
  }
  return children;
};
const SC = {
  Container: styled.div`
    position: relative;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  `,
};
